import type { Prospect } from './types';
import graphqlClient from './client';
import gql from 'graphql-tag';
import {
  removeNullValueFromArray,
  type ProspectsWithPaginationByJobIdProps,
} from './utils';
import { prospect } from './fragments/prospect.graphql';

export interface PageInfo {
  preFilterTotal: number;
  total: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
}

export interface RoleRequirementFilterCount {
  id: string;
  count: number;
}

export interface FilterCounts {
  rrFilterCounts?: RoleRequirementFilterCount[];
}

export interface BucketStatusCounts {
  newCount?: number;
  viewedCount?: number;
  inboxCount?: number;
  prescreenCount?: number;
  shortlistCount?: number;
  interviewCount?: number;
  offerCount?: number;
  acceptCount?: number;
  notSuitableCount?: number;
  totalCount?: number;
}

export interface ProspectsResult {
  nodes: Prospect[];
  pageInfo?: PageInfo;
  filterCounts?: FilterCounts;
  bucketCounts?: BucketStatusCounts;
}

export const query = gql`
  query ProspectsWithPaginationByJobId(
    $jobId: ID!
    $advertiserId: ID!
    $searchText: String
    $bucket: Bucket
    $sort: Sort
    $sortOrder: SortOrder
    $pageNumber: Int
    $pageSize: Int
    $filters: ProspectFilters
    $homeLocationDescriptionInput: CM_LocationDescriptionInput!
  ) {
    prospectsWithPaginationByJobId(
      input: {
        jobId: $jobId
        advertiserId: $advertiserId
        searchText: $searchText
        bucket: $bucket
        sort: $sort
        sortOrder: $sortOrder
        pageNumber: $pageNumber
        pageSize: $pageSize
        filters: $filters
      }
    ) {
      filterCounts {
        rrFilterCounts {
          id
          count
        }
      }
      bucketCounts {
        newCount
        viewedCount
        inboxCount
        prescreenCount
        shortlistCount
        interviewCount
        offerCount
        acceptCount
        notSuitableCount
        totalCount
      }
      pageInfo {
        pageNumber
        pageSize
        preFilterTotal
        total
        totalPages
      }
      nodes {
        ...prospect
      }
    }
  }
  ${prospect}
`;

const fetchProspectsWithPaginationByJobId = async (
  variables: ProspectsWithPaginationByJobIdProps,
): Promise<ProspectsResult> => {
  const result = await graphqlClient.query({
    variables,
    query,
  });

  const prospectsResult = result.data.prospectsWithPaginationByJobId;
  removeNullValueFromArray(prospectsResult.nodes);

  return prospectsResult;
};

export default fetchProspectsWithPaginationByJobId;
